import { render, staticRenderFns } from "./ingestPaymentMethod.vue?vue&type=template&id=2652f086&scoped=true&"
import script from "./ingestPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./ingestPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./ingestPaymentMethod.vue?vue&type=style&index=0&id=2652f086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652f086",
  null
  
)

export default component.exports